import API from "../services/api";
import StorageService from '../services/general/storage';
import CollectionsService from './general/collections';
import UserService from '../services/users';
import moment from 'moment';
const attribute = "workorders";
const uuidv1 = require('uuid/v1');

const Service = {
  createNewOrder: (userID) => {
    return new Promise((resolve, reject) => {
      let order = {};
      order.name = 'Week ' + moment(new Date()).format('w')
      order.user = userID;
      order.guid = userID + '-' + uuidv1();
      order.status = 0; //0 = concept
      order.lastmodified = new Date();
      order.created = new Date();

      Service.save(order, true)
        .then(result => {
          resolve(order);
        })
        .catch(err => {
          resolve(order);
        })
    })

  },
  getStatusLabel: status => {
    switch (status) {
      case 0:
        return 'Concept';
      case 1:
        return 'In afwachting goedkeuring';
      case 2:
        return 'Actie vereist';
      case 3:
        return 'Goedgekeurd';
      default:
        return 'Onbekend';
    }
  },
  isStatusReadOnly: status => {
    switch (status) {
      case 0:
        return false;
      case 1:
        return true;
      case 2:
        return false;
      case 3:
        return true;
      default:
        return true;
    }
  },
  get: guid => {

    return new Promise((resolve, reject) => {
      API.get(guid ? attribute + "/" + guid : attribute).then(
        result => {
          //check storage
          StorageService.getCollectionObject(attribute, guid).then(
            (foundStorage) => {
              let foundItems = foundStorage.filter ? foundStorage.filter((item) => { return item.user === UserService.currentUser()._id }) : foundStorage;
              let compared = CollectionsService.combineByModifiedDate(result, foundItems);
              resolve(compared)
            },
            (err) => {
              resolve(result)
            }
          )
        },
        error => {
          StorageService.getCollectionObject(attribute, guid).then(
            (foundStorage) => {
              let foundItems = foundStorage.filter ? foundStorage.filter((item) => { return item.user === UserService.currentUser()._id }) : foundStorage;
              resolve(foundItems);
            },
            (err) => {
              reject(err);
            }
          )
        }
      );
    });
  },
// getAdmin: guid => {
   getAdmin: year => {
    return new Promise((resolve, reject) => {
      //API.get(guid ? attribute + "/" + guid : attribute, null, 'admin=true&userinfo=true').then(

      API.get(attribute, null, 'admin=true&userinfo=true&year='+year).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getForUser: userID => {
    return new Promise((resolve, reject) => {
      API.get(attribute + "/user/" + userID).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  save: (item, saveLocal) => {
    item.lastmodified = new Date();
    if (item.status === 0) {
      if (saveLocal) Service.localSave(item);
    } else {
      StorageService.deleteCollectionObject(attribute, item.guid);
    }
    return new Promise((resolve, reject) => {
      if (item._id) { 
        API.post(attribute + "/" + item.guid, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },
  localSave: (item) => {
    return new Promise((resolve, reject) => {
      StorageService.setCollectionObject(attribute, item.guid, item);
      resolve();
    });
  },
  delete: (item) => {
    return new Promise((resolve, reject) => {
      StorageService.deleteCollectionObject(attribute, item.guid);
      if( item._id){
        API.deleteItem(attribute + "/" + item._id).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },
  checkComplete: (wordOrder, workOrderItems) => {
    let complete = true;
    for (let i = 0; i < workOrderItems.length; i++) {
      if (workOrderItems[i].location === 0) {
        complete = false;
      }
    }
    return complete;
  }
};

export default Service;
